import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules, ActivatedRouteSnapshot  } from '@angular/router'; 
import { PagesComponent } from './pages/pages.component';
import { BlankComponent } from './pages/blank/blank.component';
import { SearchComponent } from './pages/search/search.component';
import { NotFoundComponent } from './pages/errors/not-found/not-found.component';
import { ManageComponent } from './pages/manage/manage.component';
import { ProductMockupComponent } from './pages/product-mockup/product-mockup.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/cr',
    pathMatch: 'full',
  },
  {
    path: '', 
    component: PagesComponent, 
    children:[
      { path: 'cr', loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule), data: { breadcrumb: 'Dashboard' }  },          
      { path: 'blank', component: BlankComponent, data: { breadcrumb: 'Blank page' } },
      { path: 'search', component: SearchComponent, data: { breadcrumb: 'Search' } },
      {path:'products', component: ManageComponent},
      {path:'products/designs', component: ProductMockupComponent}
    ]
  },
  { path: 'login', loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule) },
  { path: 'register', loadChildren: () => import('./pages/register/register.module').then(m => m.RegisterModule) },
  { path: '**', component: NotFoundComponent }
]; 

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules, // <- comment this line for activate lazy load
      relativeLinkResolution: 'legacy',
      // useHash: true
    })
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }